import { render, staticRenderFns } from "./ListStrategies.vue?vue&type=template&id=400a657c&"
import script from "./ListStrategies.vue?vue&type=script&lang=js&"
export * from "./ListStrategies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports